import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";

interface UpdateTaxSubmissionAgencyDataRequest {
    taxSubmissionId: string;
    agencyId: string;
    sendDate: Date;
}

export const useUpdateTaxSubmissionAgencyData = () => {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders({ method: "PATCH" });
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (request: UpdateTaxSubmissionAgencyDataRequest) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${request.taxSubmissionId}/update-agency-data`,
                {
                    headers,
                    method: "PATCH",
                    body: JSON.stringify({
                        agencyId: request.agencyId,
                        sendDate: dayjs(request.sendDate).toISOString(),
                    }),
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissions"],
            });
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissionDetail"],
            });
        },
        meta: {
            errorMessage: t("errors.messages.updateAgencyData"),
        },
    });

    return mutation;
};
